import styled, { keyframes } from 'styled-components'

export const TypingWrapper = styled.h2`
  font-weight: 700;
  color: #030852;
  text-align: center;
  margin-top: 0px;
  margin-bottom: 24px;

  font-size: clamp(20px, 5vw, 48px);

  span {
    color: #f7931e;
  }
`

const blink = keyframes`
  0% { opacity: 1 }
  50% { opacity: 0 }
  100% { opacity: 1 }
`

export const Cursor = styled.span`
  display: inline-block;
  margin-left: 2px;
  animation: ${blink} 0.8s infinite;
`
